

import * as yup from "yup";

export const Inputs = [
  {
    name: "phone",
    label: { ar: "رقم الجوال", en: "Mobile Number" },
    type: "text",
    inputType: "number",
    limit: 11,
    placeholder: { ar: "", en: "" },
    col: "12",
  },
  {
    name: "password",
    label: { ar: "كلمة المرور", en: "Password" },
    type: "password",
    isPassword: true,
    placeholder: { ar: "", en: "" },
    col: "12",
  },
  {
    name: 'rememberMe',
    type: 'checkbox',
    label: { ar: 'تذكرنى', en: 'Remeber me' },
    col: '12'
  }

]

export const config = {
  url: '/signin',
  loginFlag: true,
  redirect: false,
  Sendbtn: { ar: 'دخول', en: 'Login' },
  submitLabels: ['phone', 'password'],

}


export const Validation = yup.object().shape({
  phone: yup.string().required({ ar: 'يجب ادخال  رقم الجوال *', en: 'Phone Number us required*' }),
  // .typeError({ar:'يجب ادخال رقم الهاتف *',en:'Phone number is not valid *'}),
  password: yup.string().required({ ar: "يجب ادخال كلمة المرور *", en: 'Password is required*' }),

})